// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__SdyFq","sendOtp":"AuthorizeToLogin_sendOtp__7w6eY"};